export function parseLocalStorage(key) {
  const json = window.localStorage.getItem(key);
  if (!json) return null;
  return JSON.parse(json);
}
